import React from "react";
import { useLang } from "@/context/LanguageContext";
import { HOME } from "@/constants/testIds";

const Marquee = () => {
  const { t } = useLang();
  const line = t.marquee;

  return (
    <div
      data-testid={HOME.marquee}
      className="relative overflow-hidden border-y border-white/10 bg-black py-4 md:py-6 space-y-3"
    >
      {/* Row 1 — forward */}
      <div className="marquee-track font-display uppercase text-white/85 text-[9vw] md:text-[6vw]">
        {Array.from({ length: 10 }).map((_, i) => (
          <span key={i} className={i % 2 === 0 ? "text-white" : "text-white/25"}>
            {line}
          </span>
        ))}
      </div>
      {/* Row 2 — reverse, editorial serif */}
      <div className="marquee-track marquee-reverse font-editorial italic text-[7vw] md:text-[4vw]">
        {Array.from({ length: 10 }).map((_, i) => (
          <span
            key={i}
            className={
              i % 2 === 0 ? "text-pink-400/90" : "text-white/40"
            }
          >
            {line}
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 md:w-40 bg-gradient-to-r from-black to-transparent z-10" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 md:w-40 bg-gradient-to-l from-black to-transparent z-10" />
    </div>
  );
};

export default Marquee;
